import axios from 'axios';

export const axiosInstance = axios.create({
  baseURL: 'https://backend-furniture.vercel.app/v1/api',
});

export const ProductAPI = {
  GET: '/product',
};
